import React from "react";
import styled from "styled-components";
import {
  textClickAnim,
  scaleOnClickAnim,
  whiteBgOnClickAnim,
  OPboxInAnim,
  OPboxOutAnim,
  OPfadeInAnim,
  OPfadeOutAnim,
  btnRotateAnim,
} from "../../animations";
export const OPContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  scrollbar-width: none !important;
  font-size: 20px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${(p) =>
    p.aboveAnim || p.settingsAnim ? OPfadeInAnim : OPfadeOutAnim};
  animation-duration: 0.167s;
  animation-fill-mode: forwards;
  animation-duration: ${(p) =>
    p.aboveAnim || p.settingsAnim ? "0.117s" : "0.167s"};
  background-color: rgba(219, 70, 70, 0.75);
  pointer-events: ${(p) => (p.soundPlayed ? "none" : "auto")};
  &&.prov {
    background-color: rgba(219, 70, 70, 1);
  }
`;
export const OPDarkContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  scrollbar-width: none;
  font-size: 20px;
  background: #483b3b;
  color: #db4646;
  animation: ${(p) => (p.aboveAnim ? OPfadeInAnim : OPfadeOutAnim)};
  animation-duration: 0.167s;
  animation-fill-mode: forwards;
  display: flex;
  justify-content: center;
  span {
    background: #db4646 !important;
  }
  g {
    stroke: #483b3b;
  }
`;

export const OPWrapper = styled.div`
 
  @media screen and (min-height: 100px) {
    transform: scale(0.14);
  }
  @media screen and (min-height: 200px) {
    transform: scale(0.3);
  }
  @media screen and (min-height: 250px) {
    transform: scale(0.38);
  }
  @media screen and (min-height: 300px) {
    transform: scale(0.45);
  }
  @media screen and (min-height: 350px) {
    transform: scale(0.5);
  }
  @media screen and (min-height: 400px) {
    transform: scale(0.6);
  }
  @media screen and (min-height: 450px) {
    transform: scale(0.7);
  }
  @media screen and (min-height: 500px) {
    transform: scale(0.75);
  }
  @media screen and (min-height: 550px) {
    transform: scale(0.8);
  }
  @media screen and (min-height: 600px) {
    transform: scale(0.9);
  }
  @media screen and (min-height: 667px) {
    transform: scale(1);
  }
`;
export const OPBox = styled.div`
  padding: 60px 30px 0;
  width: 375px;
  height: 667px;
  overflow-y: scroll;
  scrollbar-width: none;
  margin: auto;
  position: relative;
  animation: ${(p) =>
    p.aboveAnim || p.settingsAnim ? OPboxInAnim : OPboxOutAnim};
  animation-duration: ${(p) =>
    p.aboveAnim || p.settingsAnim ? "0.500s" : "0.550s"};
  animation-fill-mode: forwards;

  :last-child {
    margin-bottom: 60px;
  }
`;
export const OPHeader = styled.div`
  font-size: 26px;
  text-transform: uppercase;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  span {
    background: #ffb000;
    border-radius: 50%;
    height: 36px;
    width: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    animation: ${(p) =>
      p.close
        ? scaleOnClickAnim
        : p.aboveAnim || p.settingsAnim
        ? btnRotateAnim
        : null};
    animation-duration: ${(p) => (p.close ? "0.333s" : "0.5s")};
    animation-fill-mode: forwards;
    pointer-events: ${(p) => (p.soundPlayed ? "none" : "auto")};
    :after {
      content: "";
      position: absolute;
      height: 100%;
      width: 100%;
      background: #ffffff;
      border-radius: 38px;
      opacity: 0;
      right: 50%;
      bottom: 50%;
      transform: translate(50%, 50%);
      animation: ${(p) => (p.close ? whiteBgOnClickAnim : null)};
      animation-duration: 0.5s;
      animation-fill-mode: forwards;
    }
  }
`;

export const OPTitle = styled.div`
  margin-bottom: 45px;
  cursor: pointer;
  animation: ${(p) => (p.prov || p.history || p.rules ? textClickAnim : null)};
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
`;

export const OPDescription = styled.div`
  margin-bottom: 30px;
  line-height: 1.33;
  h3 {
    font-size: 20px;
    margin-bottom: 8px;
  }
  p {
    font-size: 12px;
    font-family: "GT America, regular";
  }
`;
const Input = styled.input`
  background: none;
  & {
    -webkit-appearance: none;
    width: 160px;
    margin: 11.5px 0;
  }
  &:focus {
    outline: none;
  }
  &::-webkit-slider-runnable-track {
    width: 160px;
    height: 3px;
    cursor: pointer;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    background: #ffb000;
    border-radius: 1px;
    border: 0px solid rgba(0, 0, 0, 0.95);
  }
  &::-webkit-slider-thumb {
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    border: 0px solid #000000;
    height: 26px;
    width: 26px;
    border-radius: 13px;
    background: #ffb000;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -11.5px;
  }
  &:focus::-webkit-slider-runnable-track {
    background: #ffb205;
  }
  &::-moz-range-track {
    width: 160px;
    height: 3px;
    cursor: pointer;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    background: #ffb000;
    border-radius: 1px;
    border: 0px solid rgba(0, 0, 0, 0.95);
  }
  &::-moz-range-thumb {
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    border: 0px solid #000000;
    height: 26px;
    width: 26px;
    border-radius: 13px;
    background: #ffb000;
    cursor: pointer;
  }
  &::-ms-track {
    width: 160px;
    height: 3px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }
  &::-ms-fill-lower {
    background: #faac00;
    border: 0px solid rgba(0, 0, 0, 0.95);
    border-radius: 2px;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
  }
  &::-ms-fill-upper {
    background: #ffb000;
    border: 0px solid rgba(0, 0, 0, 0.95);
    border-radius: 2px;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
  }
  &::-ms-thumb {
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    border: 0px solid #000000;
    height: 26px;
    width: 26px;
    border-radius: 13px;
    background: #ffb000;
    cursor: pointer;
    height: 3px;
  }
  &:focus::-ms-fill-lower {
    background: #ffb000;
  }
  &:focus::-ms-fill-upper {
    background: #ffb205;
  }
`;

export const OPDescriptionContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
`;

export const OPDescriptionBox = styled.div`
  p:first-child {
    font-family: "GT America, boldN";
    margin-bottom: 10px;
  }
`;
export const MenuBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  border-radius: 38px;
  margin-right: 10px;
  background: #db4646;
  padding: 0 11px;
  color: #ff3920;
  font-size: 12px;
  height: 42px;
  width: 42px;
  svg {
    width: 24px;
    height: 24px;
    g {
      stroke: #483b3b;
    }
  }
  @media only screen and (min-width: 375px) {
    font-size: 14px;
  }
`;
export const OPDescriptionIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  border-radius: 38px;
  background: #ffb000;
  margin-right: 10px;
  color: #ff3920;
  font-size: 12px;
  height: 42px;
  width: 42px;
  padding: 0 11px;
  svg {
    width: 20px;
    height: 20px;
    g {
      stroke: #ff3920;
    }
  }
  @media only screen and (min-width: 375px) {
    font-size: 14px;
  }
`;
export const OPDescriptionBigIcon = styled.div`
  width: 30%;
  padding: 5px;
  border-radius: 38px;
  background: #ffb000;
  color: #ff3920;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p {
    font-size: 12px;
    line-height: 1;
    font-family: "GT America, bold";
  }
  @media only screen and (min-width: 375px) {
    p {
      font-size: 14px;
    }
  }
`;
export const OPDescriptionSkipIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  border-radius: 38px;
  background: #e7e2de;
  margin-right: 10px;
  color: #ff3920;
  font-size: 12px;
  height: 42px;
  width: 42px;
  padding: 0 10px;
  @media only screen and (min-width: 375px) {
    font-size: 14px;
  }
`;

export const OParrows = styled.div`
  height: 42px;
  background: #db4646;
  border-radius: 38px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  width: 30%;
  margin-right: 10px;
  color: #483b3b;
  padding: 5px 10px;
  margin-right: 10px;
  color: #483b3b;
  svg {
    margin-right: 5px;
    g {
      stroke: #ffb000;
    }
  }
  span {
    margin: 0 5px;
    background: transparent;
    color: #ffb000;
  }
`;

export const Volume = ({ saveUserSetting, value, handleVolumeLocal }) => {
  return (
    <label
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: "pointer",
      }}
    >
      <div>Volume</div>
      <Input
        defaultValue={value}
        onMouseUp={(e) => {
          saveUserSetting(e.target.value);
        }}
        onTouchEnd={(e) => {
          saveUserSetting(e.target.value);
        }}
        onChange={(e) => {
          handleVolumeLocal(e.target.value);
        }}
        type="range"
        max="1"
        min="0"
        step="0.1"
      />
    </label>
  );
};
